export const env = {
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string,
  API_GATEWAY_BASE_URL: process.env.REACT_APP_API_GATEWAY_BASE_URL as string,
};

// Add more detailed logging
console.log('Environment Variables:', {
  REACT_APP_GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  REACT_APP_API_GATEWAY_BASE_URL: process.env.REACT_APP_API_GATEWAY_BASE_URL,
  NODE_ENV: process.env.NODE_ENV,
  all: process.env,
});

if (!env.GOOGLE_MAPS_API_KEY) {
  console.error('Missing REACT_APP_GOOGLE_MAPS_API_KEY environment variable');
}

if (!env.API_GATEWAY_BASE_URL) {
  console.error('Missing REACT_APP_API_GATEWAY_BASE_URL environment variable');
}
